import { useI18n } from 'vue-i18n'
import useBlProviders from '@/composables/providers/useBlProvider'
import WorksCategoriesDt from '@/services/dataTransferModules/worksCategoriesDt'

export default function useWorksCategories(params = {
	useLocalRefs: true,
	showErrorNotificationForLoadingAllEntities: true,
}) {
	const worksCategoriesDt = new WorksCategoriesDt()
	const { t: $t } = useI18n()
	const {
		loadEntityFlags: flags,
		entities: worksCategories,
		getEntities: getWorksCategories,
		createEntity: createWorksCategory,
		entity: worksCategory,
		getEntity: getWorksCategory,
		entityPreview: worksCategoryPreview,
		getEntityPreview: getWorksCategoryPreview,
		patchEntity: patchWorksCategories,
		deleteEntity: deleteWorksCategory
	} = useBlProviders(worksCategoriesDt, Object.assign({
		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Error loading work category'),

		showErrorNotificationForLoadingOneEntity: true,
		errorNotificationTextForLoadingOneEntity: $t('Error loading work category'),

		showErrorNotificationForDeletingEntity: true,
		errorNotificationTextForDeletingEntity: $t('Failed to delete work category'),
	}, params))

	const defaults = {
		creatingWorksCategory: {
			name: '',
		},
		fieldsToPatch: ['name'],
	}

	return {
		flags,
		defaults,
		worksCategories,
		worksCategoryPreview,
		worksCategory,
		getWorksCategories,
		getWorksCategoryPreview,
		getWorksCategory,
		createWorksCategory,
		patchWorksCategories,
		deleteWorksCategory,
	}
}
